let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ahxSD"), load("i5x6e")]).then(() => parcelRequire('btHFe'));